import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'El primer domingo armé las tres recetas base. El lunes mi novia me preguntó si había contratado a alguien. No lo podía creer.',
    author: 'Matías R.',
    location: 'Buenos Aires',
    context: 'Nunca había cocinado nada'
  }, {
    text: 'Lo descargué el viernes. El domingo ya tenía la mesa puesta para toda la familia. Mi suegra me pidió la receta. La suegra me la pidió a mí.',
    author: 'Luciana P.',
    location: 'Córdoba',
    context: 'Ama de casa con cero experiencia'
  }, {
    text: 'Antes pedía comida cuatro veces por semana. Ahora cocino de lunes a viernes y me sobra plata. En el primer mes recuperé lo que pagué 10 veces.',
    author: 'Diego F.',
    location: 'Rosario',
    context: 'Vive solo, primer departamento'
  }];
  return <section className="py-10 md:py-16 bg-brand-panel/85 backdrop-blur-sm border-y border-brand-border overflow-hidden" data-id="element-255">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-257">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3 md:mb-4" data-id="element-258">
            Lo que dicen quienes ya cocinaron
          </h2>
          <div className="flex justify-center gap-1" data-id="element-259">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 text-brand-gold fill-brand-gold" data-id="element-260" />)}
          </div>
        </motion.div>

        <div className="grid grid-cols-3 gap-2 md:gap-6" data-id="element-261">
          {testimonials.map((t, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} key={i} className="bg-brand-dark p-3 md:p-8 rounded-lg md:rounded-2xl border border-brand-border relative group hover:border-brand-gold/50 transition-colors flex flex-col" data-id="element-262">
              <Quote className="hidden md:block absolute top-4 right-4 md:top-6 md:right-6 w-6 h-6 md:w-8 md:h-8 text-brand-border group-hover:text-brand-gold/20 transition-colors" data-id="element-263" />
              <p className="text-[11px] leading-snug md:text-base text-gray-300 italic mb-3 md:mb-6 relative z-10 flex-grow" data-id="element-264">
                "{t.text}"
              </p>
              <div data-id="element-265">
                <p className="font-bold text-white text-[11px] md:text-base leading-tight" data-id="element-266">
                  {t.author}{' '}
                  <span className="text-gray-500 font-normal block md:inline" data-id="element-267">
                    — {t.location}
                  </span>
                </p>
                <p className="text-[10px] md:text-sm text-brand-gold mt-1 leading-tight" data-id="element-268">
                  {t.context}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}